import { CommonModule } from "@angular/common";
import { Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { Platform } from "@ionic/angular";
import { SwimLanesService } from "src/app/services/swimlanes/swimlanes.service";
import { GameTileComponent } from "../casino-lobby/game-tile/game-tile.component";
import { LobbyNavigator } from "src/app/services/lobby/lobby-navigator.service";
import { ConfigService } from "src/app/services/config/config.service";

@Component({
    selector: 'app-swim-lanes',
    templateUrl: "./swim-lanes.component.html",
    styleUrls: ["./swim-lanes.component.scss"],
    standalone: true,
    imports: [
        CommonModule,
        GameTileComponent
    ],
    providers: [SwimLanesService]
})

export class SwimLanesComponent implements OnInit {

    @ViewChildren('widgetsContent') widgetsContents!: QueryList<ElementRef>;
    public widgetsContent: ElementRef<any>;


    @Input() currentKeyword: string;

    public swimKeyword: any[] = [];
    public swimLanesData: any[] = [];
    public swimLanes: any[] = [];
    public swimGameList: any[] = [];
    public isMobileApp = false;
    public showAllLink: boolean = false;
    public iosWeb: boolean = false;
    constructor(
        private readonly service: SwimLanesService,
        private lobbyNavigator: LobbyNavigator,
        private config: ConfigService,
        private platform: Platform
    ) {
    }

    ngOnInit(): void {
        this.isMobileApp = this.platform.is('capacitor');
        this.iosWeb = this.platform.is('ios') && this.platform.is("mobileweb");
        this.showAllLink = this.config.getConfig().FEATURE_SHOW_SWIMLANE_SHOWALL_BUTTON ? (this.config.getConfig().FEATURE_SHOW_SWIMLANE_SHOWALL_BUTTON === '1' ? true : false) : true;
        this.fetchSwimLanesData();
    }

    fetchSwimLanesData(): void {
        this.service.getSwimLanesData().subscribe({
            next: (data) => {
                this.swimLanesDataDistribution(data);
            },
            error: (error) => {
                console.error('Error fetching swim lanes data:', error);
            }
        });
    }

    private swimLanesDataDistribution(incomingStream: any): any {
        const keywordsData = incomingStream[0]?.payload;
        const gamesData = incomingStream[1]?.payload;

        const filteredKeywords = keywordsData?.filter(keywords => keywords?.subKeywords?.length > 0);
        this.swimKeyword = filteredKeywords[0]?.name.toLowerCase();
        this.swimLanes = filteredKeywords[0]?.subKeywords;
        this.swimGameList = gamesData;
    }

    scrollLeft(index: number): void {
        const scrollAmount = 200;
        const lane = this.widgetsContents.toArray()[index];
        if (lane) {
            if(this.iosWeb){
                const el = lane.nativeElement;
                const remainingScroll = el.scrollLeft;
                if (remainingScroll > 0) {
                    el.scrollBy({
                        left: -Math.min(scrollAmount, remainingScroll),
                        behavior: 'smooth'
                    });
                }
            } else {
                lane.nativeElement.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
            }
        }
    }

    scrollRight(index: number): void {
        const scrollAmount = 200;
        const lane = this.widgetsContents.toArray()[index];
        if (lane) {
            if(this.iosWeb){
                const el = lane.nativeElement;
                const maxScrollLeft = el.scrollWidth - el.clientWidth;
                const remainingScroll = maxScrollLeft - el.scrollLeft;
                if (remainingScroll > 0) {
                    el.scrollBy({ 
                        left: Math.min(scrollAmount, remainingScroll), 
                        behavior: 'smooth' 
                    });
                }
            } else {
                lane.nativeElement.scrollBy({ left: scrollAmount, behavior: 'smooth' });
            }
        }
    }


    trackByLanes(index: number, lane: any): any {
        return lane.name;
    }

    showAllGamesForSwimLane(swimLaneName): void {
        this.lobbyNavigator.showAllGamesForSwimLanes(swimLaneName);
    }
}